import {createAction} from 'redux-actions';
import {relationshipManager} from '../../../utils/api/api-endpoint-dictionary';
import callApi from '../../../utils/api/axios';

const GET_MANAGER = 'GET_MANAGER';

export default function userManager(
  state = {
    isLoading: false,
    isLoaded: false,
    hasFailed: false,
    manager: null,
    error: null
  },
  { payload, type }
) {
  switch (type) {
    case `${GET_MANAGER}_PENDING`:
      return {
        ...state,
        isLoaded: false,
        isLoading: true
      };
    case `${GET_MANAGER}_FULFILLED`:
      return {
        ...state,
        isLoaded: true,
        isLoading: false,
        manager: payload.data
      };

    case `${GET_MANAGER}_REJECTED`:
      return {
        ...state,
        isLoaded: true,
        isLoading: false,
        hasFailed: true,
        error: payload
      };
    default:
      return state;
  }
}

export const getUserManager = () => {
  return (dispatch) => {
    const action = createAction(GET_MANAGER)(callApi(relationshipManager));
    dispatch(action);
  };
};
